export default __webpack_public_path__ + "static/media/board.c568a607.svg";